"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelData = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var core_1 = require("../../../../../../shared/core/");
var FuelData_styled_1 = require("./FuelData.styled");
var FuelData = function (_a) {
    var supplyType = _a.supplyType, consumption = _a.consumption, cost = _a.cost;
    var _b = (0, core_1.useComponents)(), P = _b.P, Strong = _b.Strong, Small = _b.Small, Icon = _b.Icon;
    var colors = (0, styled_components_1.useTheme)().colors;
    return (react_1.default.createElement(FuelData_styled_1.StyledFuelData, null,
        supplyType === 'Electricity' && (react_1.default.createElement(Icon, { name: "electricity", color: colors.fuelElec, size: 48 })),
        supplyType === 'Gas' && (react_1.default.createElement(Icon, { name: "gas", color: colors.fuelGas, size: 48 })),
        react_1.default.createElement(FuelData_styled_1.StyledFuelDataContent, null,
            react_1.default.createElement(P, null,
                react_1.default.createElement(Strong, null, supplyType),
                cost && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(Strong, null, (0, core_1.major2DP)((0, core_1.majorToMinor)(cost))))),
                consumption && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(Small, null,
                        consumption.toFixed(2),
                        " kWh")))))));
};
exports.FuelData = FuelData;
